var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"next-button-container"},[_c('button',{staticClass:"next-button-button button"},[_c('span',{staticClass:"next-button-text"},[_vm._v(_vm._s(_vm.button))]),_c('svg',{staticClass:"next-button-icon",attrs:{"viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }